var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{ref:"mapRef",staticClass:"full-width google-map-height",class:_vm.confirmedPageDesktop ? 'confirmed-page-map-height' : '',attrs:{"center":{ lat: _vm.lat, lng: _vm.lng },"zoom":16,"options":{
    disableDefaultUI: true
  }}},[_c('GmapMarker',{attrs:{"icon":{
      url: _vm.markerIcon + '#custom_marker',
      labelOrigin: _vm.google && new _vm.google.maps.Point(15, -45),
      ...(this.$route.name === 'confirmed' &&
        _vm.google && { scaledSize: new _vm.google.maps.Size(29, 29) }),
      //scaledSize: this.$route.name === 'confirmed' ? google && new google.maps.Size(29, 29) : '',
    },"label":{ text: `${_vm.storeName}\n${_vm.formattedAddress}`, className: 'custom-label' },"position":{ lat: _vm.lat, lng: _vm.lng },"clickable":false,"draggable":false},on:{"click":function($event){_vm.center = { lat: _vm.lat, lng: _vm.lng }}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }